/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PatchApiV1PersonIdActivate202,
  PatchApiV1PersonIdActivate401,
  PatchApiV1PersonIdActivate404,
  PatchApiV1PersonIdActivate500,
  PatchApiV1PersonIdActivateMutationResponse,
  PatchApiV1PersonIdActivatePathParams,
} from "../../types/personRegisterController/PatchApiV1PersonIdActivate.ts";

export const patchApiV1PersonIdActivatePathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<PatchApiV1PersonIdActivatePathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const patchApiV1PersonIdActivate202Schema =
  z.any() as unknown as ToZod<PatchApiV1PersonIdActivate202>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const patchApiV1PersonIdActivate401Schema =
  z.any() as unknown as ToZod<PatchApiV1PersonIdActivate401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const patchApiV1PersonIdActivate404Schema =
  z.any() as unknown as ToZod<PatchApiV1PersonIdActivate404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const patchApiV1PersonIdActivate500Schema =
  z.any() as unknown as ToZod<PatchApiV1PersonIdActivate500>;

export const patchApiV1PersonIdActivateMutationResponseSchema = z.lazy(
  () => patchApiV1PersonIdActivate202Schema,
) as unknown as ToZod<PatchApiV1PersonIdActivateMutationResponse>;
